import {useContext} from "react";
import GlobalContext         from "../../../isp._comun/iu/contexto/GlobalContext";
import VentanaServicio       from "../../../isp.iu.servicios/reductores/ventanas/VentanaServicio";
import VentanaQueryServicios from "../../../isp.iu.servicios/reductores/ventanas/VentanaQueryServicios";
// import AbrirVentana from "../../reductores/acciones/widgets/AbrirVentana";


export default function MenuItemsServicios() {
    const {
        // dispatchPrincipal,
        // abrirNuevaVentana
        abrirVentana
    } = useContext(GlobalContext);

    return [
        {
            label: "Nuevo Servicio",
            icon: "pi pi-fw pi-plus",
            command: () => {
                // const nuevaVentana = new VentanaServicio();
                const nuevaVentana = VentanaServicio.nuevaVentanaEnModoCrear();
                abrirVentana(nuevaVentana);
                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaNuevoClienteAFacturar())
            },
        },
        {
            label: "Listar Servicios",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryServicios();
                abrirVentana(nuevaVentana);
                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaQueryClientesAFacturar())
            },
        },
        /* {
            separator: true,
        },
        {
            label: "Listar Servicios Comerciales de Internet",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
        {
            label: "Reporte de Servicios",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
         
        {
            label: "Lista de Eventos",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        },
        {
            separator: true,
        },
        {
            label: "Configuración",
            icon: "pi pi-fw pi-list",
            // command: abrirVentanaQueryFias,
        }, */
    ];
 

    
    
    
    
    
    //   return <Menubar model={items} />;
}

